<template>
  <div>
    <v-row v-if="items && items.length > 0">
      <v-col v-if="mainNews"
             cols="12" md="6">
        <v-card :color="$finColors.primaryDark"
                class="fin-news-card"
                dark
                height="268px">
          <v-col>
            <v-row>
              <v-col class="pb-0">
                <span class="date-source">
                  <fin-news-item-source-date-category :show-tag="false" :value="mainNews"/>
                </span>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pt-0">
            <router-link :to="{name: 'newsDetail', params: {id: mainNews.id}}">
              <h3>
                {{ mainNews.title }}
              </h3>
            </router-link>
            <div class="teaser-text"
                 v-html="mainNews.teaserText"/>
          </v-col>
        </v-card>
      </v-col>
      <v-col v-if="secondaryNews"
             class="d-flex flex-column"
             cols="12" md="6">
        <fin-news-list
          :items="secondaryNews"
          :show-item-teaser="false"/>
      </v-col>
      <v-col v-if="secondaryNews"
             class="d-flex justify-end align-end"
             cols="12">
        <v-btn color="transparent"
               elevation="0"
               @click="$emit('allNews')">
          Alle Nachrichten
          <v-icon>icon-arrow-link</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <p v-else class="mb-12">Keine Nachrichten verfügbar</p>
  </div>
</template>

<script>
import FinNewsItemSourceDateCategory from "@/components/common/news/NewsItemSourceDateCategory"
import FinNewsList from "@/components/pages/finNews/newsList"

export default {
  name: 'fin-company-page-news',
  components: {FinNewsList, FinNewsItemSourceDateCategory},
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    mainNews() {
      const result = this.items[0]
      return result
    },
    secondaryNews() {
      const result = this.items.filter((item, i) => {
        return i !== 0
      })
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.fin-news-card {
  font-family: 'Gilroy', sans-serif !important;

  a {
    color: #fff;
    text-decoration: none;
  }

  h3 {
    font-family: inherit !important;
    font-size: 24px;
    font-weight: bold;
    line-height: 1.1;
  }

  .teaser-text {
    font-family: inherit !important;
    font-size: 16px;
    line-height: 1.5;
  }

  .date-source {
    font-family: inherit !important;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.17;
    letter-spacing: 1px;
  }
}

.article {
  flex: 1;
  justify-content: end !important;
  flex-wrap: wrap;

  .title {
    font-family: 'Gilroy', sans-serif !important;

    a {
      text-decoration: none;
      color: $fin-color-primary-dark !important;
    }
  }
}


.news-title {
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 22px;
  letter-spacing: normal;
  margin-bottom: 8px;

  @media only screen and (max-width: 960px) {
    font-size: 1.1em;
  }
}

</style>
